import { render } from "./MessageInput.vue?vue&type=template&id=56d9bd6e&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=56d9bd6e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d9bd6e"]])

export default __exports__